import { render, staticRenderFns } from "./billing-price-structure.vue?vue&type=template&id=941e70e0&"
import script from "./billing-price-structure.vue?vue&type=script&lang=js&"
export * from "./billing-price-structure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports